import { Text, Title } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./SsoPopupSignedIn.module.scss"

// Shown by a Kodem SSO popup the browser does not let close itself: the sign-in page takes over
export const SsoPopupSignedIn = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "auth.ssoPopupSignedIn"
  })

  return (
    <div data-testid="ssoPopupSignedIn" className={styles.container}>
      <Title level={4} className={styles.title}>
        {t("title")}
      </Title>
      <Text>{t("text")}</Text>
    </div>
  )
}
